<template>
  <v-col :cols="block.cols" :xs="block.colsxs" :sm="block.colssm" :md="block.colsmd" :lg="block.colslg" :xl="block.colsxl" :offset="block.offset">
    <p v-if="block.label" :class="block.labelClass + ' primary--text'">
      {{ block.label }}
    </p>
    <v-radio-group
      v-model="form[block.radioUid]"
      class="ma-0"
      column
      hide-details
    >
      <template v-for="radioOption in block.radioComponents">
        <v-radio
          :key="radioOption.uid"
          :label="radioOption.label"
          :value="radioOption.uid"
        />
        <v-expand-transition v-if="radioOption.additionalComponents" :key="radioOption.uid + '_additional'">
          <v-row v-show="form[block.radioUid] == radioOption.uid" align="center" class="mb-3 ml-5">
            <template v-for="additionalBlock in radioOption.additionalComponents">
              <component :is="additionalBlock.component" :key="additionalBlock.uid" v-model="form[block.additionalUid][additionalBlock.uid]" :block="additionalBlock" />
            </template>
          </v-row>
        </v-expand-transition>
      </template>
    </v-radio-group>
  </v-col>
</template>

<script>
export default {
   name: 'Radio',
   model: {
      prop: 'form',
      event: 'update:form'
   },

   props: {
      block: {
         type: Object,
         required: true,
      },
      form: {
         type: Object,
         required: true,
      },
   },

   data () {
      return {
         show: false
      }
   },

   watch: {
      form: {
         deep: true,
         handler (val, oldVal) {
            this.$emit('update:form', this.form)
         }
      }
   }
}
</script>
